export default __webpack_public_path__ + "static/mousePic4-7dbb6299d034bd42d9763cc82c754824.jpg";